import { render } from "./vechicleDetailsModal.vue?vue&type=template&id=61838f82&scoped=true"
import script from "./vechicleDetailsModal.vue?vue&type=script&lang=js"
export * from "./vechicleDetailsModal.vue?vue&type=script&lang=js"

import "./vechicleDetailsModal.vue?vue&type=style&index=0&id=61838f82&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61838f82"]])

export default __exports__